// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.
import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { tumorBoardBaseUrl } from '@/settings'

export const sendMailPhysicianSchedule = async (payload) => {
  try {
    const fetchParams = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + store.getters.jwt,
      },
      body: JSON.stringify(payload),
    }
    const url = `${tumorBoardBaseUrl}/api/v1/invite_v2`
    const response = await fetchWithTimeout(url, fetchParams)
    const result = await response.json()
    if (!result) {
      return result
    }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
